
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionTemplateDialog extends Serenity.EntityDialog<QualityInspectionTemplateRow, any> {
        protected getFormKey() { return QualityInspectionTemplateForm.formKey; }
        protected getIdProperty() { return QualityInspectionTemplateRow.idProperty; }
        protected getLocalTextPrefix() { return QualityInspectionTemplateRow.localTextPrefix; }
        protected getNameProperty() { return QualityInspectionTemplateRow.nameProperty; }
        protected getService() { return QualityInspectionTemplateService.baseUrl; }
        protected getDeletePermission() { return QualityInspectionTemplateRow.deletePermission; }
        protected getInsertPermission() { return QualityInspectionTemplateRow.insertPermission; }
        protected getUpdatePermission() { return QualityInspectionTemplateRow.updatePermission; }

        protected form = new QualityInspectionTemplateForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            return btns;
        }
        // **** Validate Reference of Template in Product and Process. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let templatecheck;
            OMS.ProductInspectionService.List(
                { ContainsField: "TemplateId", ContainsText: this.entityId },
                response => { templatecheck = response.Entities }, {
                async: false
            });
            if (templatecheck != undefined && templatecheck.length > 0) {
                q.Alert("Can not Delete!", "This Template has been attached to Product", 2500, false);
                return;
            } else {
                OMS.ProcessInspectionService.List(
                    { ContainsField: "TemplateId", ContainsText: this.entityId },
                    response => { templatecheck = response.Entities }, {
                    async: false
                });
                if (templatecheck != undefined && templatecheck.length > 0) {
                    q.Alert("Can not Delete!", "This Template has been attached to Process", 2500, false);
                    return;
                }

                else {

                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            QualityInspectionTemplateService.Delete(
                                {
                                    EntityId: this.entityId
                                }, response => {
                                    Serenity.SubDialogHelper.triggerDataChange(self);
                                    self.dialogClose();
                                    window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Deleted!',
                                            text: 'Voucher Deleted',
                                            showConfirmButton: false,
                                            timer: 1500
                                        })
                                    );
                                }
                            );
                        }
                    })
                }
            }

        }
    }
}